"use client";
// It is a special fix to be able to have all index page files in the same folder

import React from "react";
import BagShipments from "../bag-shipments/page";
import { isRoleShipment, isRoleWarehouse } from "~/cores/appCore";
import QualityCheckPage from "../quality-check/page";
import { useAppProps } from "~/app/_apps/AppPropsContext";
import MetaBasePage from "~/app/(pages)/(home)/_metaBase/MetaBasePage";

export default function HomePage() {
    const { appProps } = useAppProps();
    return isRoleShipment(appProps) ? <BagShipments appProps={appProps} /> : isRoleWarehouse(appProps) ? <QualityCheckPage appProps={appProps} /> : <MetaBasePage appProps={appProps} />;
}
